var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filter-container" }, [
    _c(
      "div",
      { staticClass: "filters flex-layout" },
      _vm._l(_vm.branchFilters, function(filter) {
        return _c("branch-filter", {
          key: `filters-${filter.label}`,
          attrs: { label: filter.label, branches: filter.branches },
          on: { check: _vm.branchesChecked, uncheck: _vm.branchesUnchecked }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }